import { createStore } from 'vuex'
import { getStoredLang } from '@/utils/lang'

// 创建一个新的 store 实例
export const store = createStore({
  state () {
    return {
        unreadCount: 0,
        userCode: "123123123",
        loading: true,
        lang: getStoredLang()
    }
  },
  mutations: {
    setUnreadCount (state, value) {
      state.unreadCount = value
    },
    setUserCode (state, value) {
      state.userCode = value
    },
    setLoading (state, value) {
      state.loading = value
    },
    setLang (state, value) {
      state.lang = value
    }
  }
})

export default store